export const pubs = [
    {
        "title": "She Will Last as Long as Stones",
        "publication": "Wendy's Subway",
        "url": "https://www.wendyssubway.com/publishing/titles/she-will-last-as-long-as-stones",
        "year": "2025"
    },
    {
        "title": "four poems",
        "publication": "Tyger Quarterly",
        "url": "https://tygerquarterly.com/kathy-wu",
        "year": "2026"
    },
    {
        "title": "when will it rain",
        "publication": "Michigan Quarterly Review",
        "url": "https://sites.lsa.umich.edu/mqr/current-issue-fall-2025/",
        "year": "2025"
    },
    {
        "title": "For Let Earth",
        "publication": "Tilted House Press",
        "url": "https://www.tiltedhouse.org/shop/for-let-earth-kathy-wu-presale",
        "year": "2025"
    },
    {
        "title": "STONE",
        "publication": "Nat Brut Issue 18",
        "url": "https://www.natbrut.org/issue-eighteen",
        "year": "2025"
    },
    {
        "title": "The Color of Dislocation",
        "publication": "Permanent Record Anthology, Nightboat Books",
        "url": "https://nightboat.org/book/permanent-record-poetics-towards-the-archive/",
        "year": "2025"
    },
    {
        "title": "She’s Lived a Tongue, You’re a Concealer",
        "publication": "Ensemble Park Journal of Human + Computer Writing",
        "url": "https://www.ensemblepark.com/",
        "year": "2024"
    },
    {
        "title": "Virtual Blue, A Mouth Hold Many Things",
        "publication": " De-canon via Fonograf",
        "url": "https://fonografeditions.com/catalog/fono31-de-canon-fe-a-mouth-holds-many-things-print-anthology/",
        "year": "highlighted in BOMB Magazine, 2024"
    },
    {
        "title": "She Will Last as Long as Stones (Excerpts)",
        "publication": "Tupelo Quarterly",
        "url": "https://www.tupeloquarterly.com/poetry/kathy-wu-white-asters-tu-moon-mom-rhodendendron/",
        "year": "2024"
    },
    {
        "title": "Cabinet Memory, Speculative Spectrality, Alphabet",
        "publication": "Dialogist",
        "url": "https://dialogist.org/poetry/2024-week-05-kathy-wu",
        "year": "2024"
    },
    {
        "title": "Geopoetics",
        "publication": "Syllabus Project",
        "url": "https://syllabusproject.org/geopoetics/",
        "year": "2023"
    },
    {
        "title": "Who’s Talking: DaDa and Found Text, TextGenEd Curriculum",
        "publication": "WAC Clearinghouse sponsored by Colorado State University Department of English",
        "url": "https://wac.colostate.edu/repository/collections/textgened/",
        "year": "2023"
    },
    {
        "title": "Review of Yaxkin Melchy’s Poetechnics: Diseños del Nuevo Mundo",
        "publication": "Rain Taxi Literary Review",
        "url": "https://raintaxi.com/volume-28-number-4-winter-2023-112/",
        "year": "2023"
    },
    {
        "title": "Building an Asian American Movement: Visioning Towards Abolition",
        "publication": "Printed Matter",
        "url": "https://pm.linkedbyair.net/catalog/59883/",
        "year": "2022"
    },
    {
        "title": "Erotic Event Listeners",
        "publication": "Critical Coding Cookbook, The New School",
        "url": "https://criticalcode.recipes/",
        "year": "2022"
    },
    {
        "title": "Pulmō Plastics, Grow The Future: Visions of BioDesign",
        "publication": "MoMA & BioDesign Challenge",
        "url": "https://www.biodesignchallenge.org/bdc-book/growthefuture",
        "year": "2022"
    },
    {
        "title": "Touching Each Other Through Semiconduction",
        "publication": "New River Journal of Digital Art + Literature, UVA",
        "url": "https://thenewriver.us/category/fall-2022-issue/",
        "year": "2022"
    },
    {
        "title": "Instructions for Going On",
        "publication": "Taper #6, MIT",
        "url": "https://taper.badquar.to/6/about.html",
        "year": "2021"
    }
] as const